window.addEventListener('load', function() {
    localStorage.removeItem('product_recommendation');
    // card1-row1
    $('.row-1 .btn-item').off('click');

    // card1-row2 联动
    $('.row-2 .btn-item').on('click', function() {
        let $this = $(this);
        let index = $this.index();
        let isSelected = $this.hasClass('selected');
        let isLast = !$this.nextAll('.selected').length; // 检查右侧是否没有选中的了
        
        if (isSelected && isLast) {
            // 如果点的是最后一个已选中的，则取消它
            $this.removeClass('selected');
        } else {
            // 否则，选中自己及左侧所有，并清除右侧所有
            $this.addClass('selected').prevAll().addClass('selected');
            $this.nextAll().removeClass('selected');
        }
        
        // ***高级功能与价格联动处理，0是点击第一个***
        minPriceFun(2,$this,index)
    });



    function minPriceFun(rowNumber,$this,index){
        let row2_selected = $(".grid-layout.row-2 .selected").length
        let row3_selected = $(".grid-layout.row-3 .selected").length
        
        // row2, row3 只选择一项处理
        let getRowPrice =''
        if(row2_selected == 0 || row3_selected == 0){
            if($this.hasClass('selected')){
                getRowPrice = Number($this.attr("data-price"))
                
                if(getRowPrice > 1500){
                    $(".card2_price .btn-item").removeClass("selected").addClass("noClick");
                }else{
                    $(".card2_price .btn-item").removeClass("noClick");
                }
            }else{
                if(row2_selected == 0){
                    getRowPrice = Number($(`.grid-layout.row-3 .btn-item:nth-child(${row3_selected})`).attr("data-price"))
                }else if(row3_selected == 0){
                    getRowPrice = Number($(`.grid-layout.row-2 .btn-item:nth-child(${row2_selected})`).attr("data-price"))
                }
            }
            $("#min-price").val(getRowPrice)
            $(".minPrice_tips").fadeIn(100).find("span").text(`$${getRowPrice}`)
            $(".productRecommend_card .noInput").css("opacity","0")
        }
        // row2 & row3 多选情况
        if(row2_selected != 0 && row3_selected != 0){
            let multiRowPrice = ''
            $(".card2_price .btn-item").removeClass("selected").addClass("noClick");
            if(row2_selected == 1){
                multiRowPrice = '2788'
            }else if(row2_selected == 2){
                multiRowPrice = '3000'
            }else if(row2_selected == 3){
                multiRowPrice = '5000'
            }else if(row2_selected == 4){
                multiRowPrice = '5000'
            }
            $("#min-price").val(multiRowPrice)
            $(".minPrice_tips").fadeIn(100).find("span").text(`$${multiRowPrice}`)
            $(".productRecommend_card .noInput").css("opacity","0")
        }
        
        // 第一个处理
        if(row2_selected == 0 && row3_selected == 0){
            $(".card2_price .btn-item").removeClass("noClick");
            if(!$this.hasClass('selected')){ // 如果选中再给最低价赋值
                $("#min-price").val("")
                $(".minPrice_tips").hide()
            }
        }
    }

    // card1-row3
    $('.row-3 .btn-item').on('click', function() {
        let index = $(this).index()
        $(this).toggleClass('selected');
        minPriceFun(3,$(this),index)
    });


    // 2. card2 预算区：单选 
    $('.card2_price .btn-item').on('click', function() {
        if($(this).hasClass('noClick')){
            return false
        }else{
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected'); // 已选中则取消
            } else {
                $(this).addClass('selected').siblings().removeClass('selected'); // 选中自己，排他
                $("#min-price,#max-price").val("")
                $(".productRecommend_card .noInput").css("opacity","0")
            }
        }
    });
    // 输入框和单选联动处理
    $('#min-price,#max-price').on('change', function() {
        let minPrice = $("#min-price").val();
        let maxPrice = $("#max-price").val();
        if(minPrice!='' || maxPrice!= ''){
            $(".card2_price .btn-item").removeClass("selected")
            $(".productRecommend_card .noInput").css("opacity","0")
        }
    });			


    // 3. card3 品牌选择
    $('.card3_layout .btn-item').on('click', function() {
        $(this).toggleClass('selected');
    });



    // 4. 获取选择的数据
    $('#get-data').on('click', function() {
        let minPrice = ''
        let maxPrice = ''
        if($('.card2_price .selected').length>0){
            let selectedPrice = $('.card2_price .selected').text()
            if(selectedPrice.includes('–')){
                minPrice = selectedPrice.split('–')[0].replace(/\$/g, '').trim()
                maxPrice = selectedPrice.split('–')[1].replace(/\$/g, '').trim()
            }
            if(selectedPrice.includes('Under')){
                maxPrice = selectedPrice.split('$')[1]
            }
            if(selectedPrice.includes('+')){
                minPrice = selectedPrice.match(/\d+/g)
            }
        }else{
            minPrice = $('#min-price').val()
            maxPrice = $('#max-price').val()
        }


        let selectedData = {
            row1: [], 
            row2:[],
            row3: [],
            price:{
                min: minPrice,
                max: maxPrice
            },
            choosebrand:[],
            inputBrand: $('.cs_vehicle_rands input').val()
        };
        // card1-第一项
        $('.row-1 .selected span').each(function() {
            selectedData.row1.push($(this).text().trim());
        });
        // card1-第二项
        $('.row-2 .selected span').each(function() {
            selectedData.row2.push($(this).text().trim());
        });
        // card1-第三项
        $('.row-3 .selected span').each(function() {
            selectedData.row3.push($(this).text().trim());
        });
        
        // card2-价格不为空判断
        if(selectedData.choosePrice == 'None' && $("#min-price").val()=='' && $("#max-price").val()==''){
            $(".card2_price").siblings(".noInput").css("opacity",'1').parent(".productRecommend_card").addClass("error")
        }else{
            $(".card2_price").siblings(".noInput").css("opacity",'0').parent(".productRecommend_card").removeClass("error")
        }
        
        // card3
        $('.card3_layout .selected').each(function() {
            selectedData.choosebrand.push($(this).text().trim());
        });
        // 品牌不为空判断
        if(selectedData.choosebrand.length == 0 && $(".cs_vehicle_rands input").val() ==''){
            $(".cs_vehicle_rands").siblings(".noInput").css("opacity",'1').parent(".productRecommend_card").addClass("error")
        }else{
            $(".cs_vehicle_rands").siblings(".noInput").css("opacity",'0').parent(".productRecommend_card").removeClass("error")
        }
        
        // 判断通过展示推荐弹框
        console.log("Captured Data:", selectedData,$(".productRecommend .error").length);
        if($(".productRecommend .error").length==0){
            let getHref = $(this).attr("data-href")
            // 存数据，跳转页面
            localStorage.setItem('product_recommendation', JSON.stringify(selectedData));
            window.location.href= getHref
        }
    });



    // 关闭弹框
    // $(".recommend_title .close").click(function(){
    //     $(".recommendedPopup").fadeOut(300)
    // })
    // // 点击空白关闭弹框
    // $(".recommendedPopup").click(function(e) {
    //     var modal = $('.recommendInfo');
    //     if (!modal.is(e.target) && modal.has(e.target).length === 0 && !$(e.target).is('.recommend_title .close')) {
    //         $(".recommendedPopup").fadeOut(300)
    //     }
    // });
});